import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next/useAnalyticsEvents';

const INLINE_CREATE_AGENT_ACTION_SUBJECT_ID = 'inlineCreateAgentItem';

export const useInlineCreateAgentItemScreenEvent = (source: string | undefined) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendScreenEvent',
			data: {
				name: INLINE_CREATE_AGENT_ACTION_SUBJECT_ID,
				attributes: {
					source,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, source]);
};
